module.exports = __webpack_public_path__ + "img/logo-paperstprojects.f677c71e.png";